import { render, staticRenderFns } from "./OfferDetail.vue?vue&type=template&id=5f5120ae&scoped=true&"
import script from "./OfferDetail.vue?vue&type=script&lang=ts&"
export * from "./OfferDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OfferDetail.vue?vue&type=style&index=0&id=5f5120ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5120ae",
  null
  
)

export default component.exports